import { useEffect, useState } from 'react'
import { confirmable, createConfirmation, ReactConfirmProps } from 'react-confirm'
import { VideoModal } from 'stories/components'

const VideoDialog = ({ show, proceed, confirmation, options }: ReactConfirmProps | any) => {
  const [lastUpdatedAt, setLastUpdatedAt] = useState(Date.now())
  useEffect(() => {
    setLastUpdatedAt(Date.now())
  }, [show])

  return (
    <VideoModal
      isOpen={show}
      onOk={() => proceed(true as any)}
      onCancel={() => proceed(false as any)}
      lastUpdatedAt={lastUpdatedAt}
      content={confirmation}
      options={options}
    />
  )
}

const confirmDlg = confirmable(VideoDialog)

const createVideoModal = createConfirmation(confirmDlg)

export const showVideo = (content: string | JSX.Element, options: Record<string, any> = {}) =>
  createVideoModal({ confirmation: content, options })
